const pathToFlags = '/assets/currency-flags/';

type CurrencyFlagProps = {
  currency: string;
  className?: string;
};

export const CurrencyFlag = ({ currency, className }: CurrencyFlagProps) => {
  return (
    <img
      src={`${pathToFlags}${currency}.svg`}
      alt={currency}
      className={className}
    />
  );
};
